import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';

import { SectionTitle } from '@/ui/index';

import { Download } from '../../SvgComponents/Download';

import styles from './ColorCards.module.scss';

const ColorCards = ({ data, className }) => {
  const renderTrueButton = (buttonData, index) => {
    if (buttonData.button_type === 'download') {
      return (
        <a
          className={styles['color-card__button']}
          key={index}
          href={buttonData?.button_download_file}
          download
        >
          {buttonData?.button_text}
          <Download />
        </a>
      );
    }

    return (
      <Link href={buttonData?.slug}>
        <a
          className={classNames(
            styles['color-card__button'],
            styles['color-card__button--link'],
          )}
        >
          {buttonData?.button_text}
          <Download />
        </a>
      </Link>
    );
  };

  const renderColorCards = (item, index) => {
    return (
      <article className={styles['color-card']} key={index}>
        {item?.icon && (
          <div className={styles['color-card__icon-wrapper']}>
            <Image
              className={styles['color-card__icon']}
              src={item?.icon}
              alt='icon'
              title='icon'
              loading='lazy'
              width={24}
              height={24}
            />
          </div>
        )}
        {item?.title && (
          <SectionTitle
            titleModify={classNames([
              styles['color-card__title'],
              'title--medium',
            ])}
          >
            {item?.title}
          </SectionTitle>
        )}
        {item?.description && (
          <span
            className={styles['color-card__desc']}
            dangerouslySetInnerHTML={{ __html: item?.description }}
          />
        )}
        {item?.button_text && renderTrueButton(item)}
      </article>
    );
  };

  return (
    <section className={classNames(styles['color-cards'], className)}>
      {data?.title && (
        <SectionTitle
          className={styles['color-cards__title']}
          titleModify='title--large'
          icon={data?.icon}
        >
          {data?.title}
        </SectionTitle>
      )}
      {data?.items?.length > 0 && (
        <div className={styles['color-cards__inner']}>
          {data?.items?.map(renderColorCards)}
        </div>
      )}
    </section>
  );
};

export default ColorCards;
